import type { ModuleFile } from '../../core/modules.ts';

// Módulo «script»: manifiesto. Las pantallas se cargan de forma perezosa.
export const manifests: ModuleFile['manifests'] = [
  {id:'scripts', title:'Guiones', path:'guiones', nav:{group:'Trabajo',label:'Guiones',icon:'✎',order:2.5}, load:()=>import('./ScriptsPage.tsx').then(m=>({default:m.ScriptsPage}))},
  {id:'standalone-script',title:'Guion',path:'guiones/:scriptId',load:()=>import('./StandaloneScriptPage.tsx').then(m=>({default:m.StandaloneScriptPage}))},
  {
    id: 'script',
    title: 'Guion',
    projectTab: { segment: 'guion', label: 'Guion', order: 2 },
    load: () => import('./ScriptPage.tsx').then((m) => ({ default: m.ScriptPage })),
  },
];
